<template>
  <img
    :src="visSrc"
    :height="height || width"
    :width="width || height"
    style="vertical-align: middle;"
  >
</template>

<script>
export default {
  components: {
  },
  props: {
    src: String,
    height: String,
    width: String,
    replaceTbOrigin: Boolean,
    traPlatform: String,
  },
  computed: {
    visSrc () {
      if (this.replaceTbOrigin && this.src) {
        // http://g.search1.alicdn.com/img/i1/130984857/O1CN01xw3eE51lkYJtBgpy1_!!0-saturn_solar.jpg
        return this.src.replace(/http:\/\/g.search.?\./, 'https://g-search1.')
      }
      return this.src || require('./images/defaultImg.png')
    }
  }
}
</script>

<style lang="postcss" scoped>
img {
  vertical-align: middle;
}
.traPlatformIcon {
  position: absolute;
  right: 0;
  top: 0;
}
</style>
